module.exports = "#emp-notification-div {\r\n  min-height: 85vh;\r\n}\r\n\r\n.emp_page_search {\r\n  margin-bottom: 10px;\r\n}\r\n\r\ntbody {\r\n  background: #fff;\r\n  text-transform: capitalize\r\n}\r\n\r\n.table-bordered>thead>tr>th {\r\n  border: 1px solid #fff !important;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  table>tbody>tr>td {\r\n    border-top: 1px solid #ccc !important;\r\n  }\r\n  .my-pagination .p_box {\r\n    margin-bottom: 30px !important;\r\n  }\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/common/notification/notification.component.css
// module id = ./src/app/common/notification/notification.component.css
// module chunks = main